import base from "/app/images/apple.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");